export enum ICDNAuxMode {
  DISABLED,
  REQUIRED,
  OPTIONAL,
}
